import { useQuery } from "react-query";
import Application from "../apiResources/Application";
import { PaginationQuery } from "./types";

interface ApplicationsQuery extends PaginationQuery {
  engagementId?: string | number;
}

const fetchApplications = async (queryData: ApplicationsQuery) => {
  const { engagementId, page, per } = queryData;

  const response = await Application.where({
    engagement_id: engagementId,
  })
    .page(page)
    .per(per)
    .stats({ total: "count" })
    .all();

  let hasMore = false;

  if (page && per) {
    hasMore = response.meta.stats.total.count > page * per;
  }

  return {
    applications: response.data,
    meta: {
      hasMore,
      total: response.meta.stats.total.count,
    },
  };
};

export const useApplications = (queryData: ApplicationsQuery) => {
  return useQuery(["applications", queryData], () =>
    fetchApplications(queryData)
  );
};
